module.exports = __webpack_public_path__ + "static/media/icon-sidebar-video.a84e986f.svg";